import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { getUserId } from '@avanta/shared/utils/storage';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { type AxiosError, type AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { MUTATION_KEYS, QUERY_KEYS } from 'constants/common';
import { ROUTES } from 'constants/routes';
import { UsersService } from 'services/users';
import { useUserStore } from 'stores/user';

export const useSetupPassword = (): UseMutationResult<
  AxiosResponse<void>,
  AxiosError,
  { password: string }
> => {
  const { t } = useTranslation(LOCIZE_NS.AUTH);
  const navigate = useNavigate();
  const user = useUserStore(state => state.user);
  const userId = user?.id ?? getUserId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MUTATION_KEYS.SET_ADMIN_PASSWORD],
    mutationFn: async (payload: { password: string }): Promise<AxiosResponse<void>> =>
      UsersService.setAdminPassword(userId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_USER] });
      toast.success(t('RecoverPassword.PasswordChange.success'));
      navigate(ROUTES.HOME);
    },
  });
};
